export default __webpack_public_path__ + "static/media/Maskgroup1.9a057c03.svg";